<template>
  <header class="mobile-header">
    <img src="../../assets/menu_fold.svg" @click="showFolder = !showFolder">
    <img src="../../assets/ont-logo.svg" @click="goHome">
    <span class="lang-icon-wrapper" @click="dialogVisible = true">
      <img src="../../assets/lang.svg">
      <sup class="lang-text">{{  $t("locale") }}</sup>
    </span>
    <FoldMenu v-show="showFolder" class="header-fold-menu" :menu="TopMenu"></FoldMenu>
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
    >
      <div
        class="lang-item"
        :class="{ 'selected': item.locale === language }"
        v-for="item in SUPPORTED_LANGUAGES"
        :key="item.locale"
        @click="() => changeLanguage(item)">
        {{ item.name }}
      </div>
    </el-dialog>
  </header>
</template>

<script>
import { langInit, changeLang, SUPPORTED_LANGUAGES } from "utils/lang";
import FoldMenu from "./FoldMenu.vue";
import { TopMenu } from '../constant'

export default {
  components: {
    FoldMenu
  },
  data() {
    return {
      showFolder: false,
      dialogVisible: false,
      SUPPORTED_LANGUAGES,
      TopMenu
    }
  },
  computed: {
    language() {
      return this.$i18n.locale
    }
  },
  mounted() {
    langInit(this.language);
  },
  methods: {
    changeLanguage(item) {
      this.$i18n.locale = item.locale;
      changeLang(this.language)
      this.dialogVisible = false
    },
    goHome() {
      if (this.$route.name !== 'Home') {
        this.$router.push({ name: 'Home' })
      }
    }
  },
}
</script>

<style scoped>
.mobile-header {
  position: fixed;
  top: 0;
  z-index: 1002;
  box-sizing: border-box;
  display: flex;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px;
  width: 100%;
  height: 55px;
}
.lang-icon-wrapper {
  position: relative;
  white-space: nowrap;
  width: 28px;
  height: 16px;
}
.lang-text {
  vertical-align: top;
  display: inline-block;
  font-size: 12px;
  text-transform: uppercase;
  transform: scale(0.6);
  transform-origin: top;
  font-weight: 500;
}
.header-fold-menu {
  position: fixed;
  top: 55px;
  left: 0;
  height: calc(100% - 55px);
  width: 100%;
  padding: 40px 24px 120px;
}
::v-deep .el-dialog__body {
  padding: 0 0 30px;
}
.lang-item {
  width: 100%;
  text-align: center;
  line-height: 16vw;
  height: 16vw;
}
.selected {
  color: #000;
  font-weight: 600;
}
</style>